import { ISwapQualityIssue } from '@nkr/models/index';
import { Panel } from 'react-bootstrap'

interface IProps {
    data: ISwapQualityIssue
}

const SwapInfo = (props: IProps) => {
    let { chainId, clusterNumber, positionNumber, transportMethod, recipientExportableDaysInNkr, kidneyPickupDateTime, kidneyPickupDateTimeActual } = props.data;

    return (
        <Panel>
            <Panel.Heading>Swap Info</Panel.Heading>
            <Panel.Body>
                <div className='row'>
                    <div className='col-lg-3'><strong>Swap #</strong></div>
                    <div className='col-lg-9'>{chainId}/{clusterNumber}/{positionNumber}</div>

                    <div className='col-lg-3'><strong>Transport Method</strong></div>
                    <div className='col-lg-3'>{transportMethod != '' ? transportMethod : '- not specified -'}</div>

                    <div className='col-lg-3'><strong>Recipient Days Waiting</strong></div>
                    <div className='col-lg-3'>{recipientExportableDaysInNkr}</div>

                    <div className='col-lg-3'><strong>Target Pickup Date/Time</strong></div>
                    <div className='col-lg-3'>{kidneyPickupDateTime != '' ? kidneyPickupDateTime : '- not specified -'}</div>

                    <div className='col-lg-3'><strong>Actual Pickup Date/Time</strong></div>
                    <div className='col-lg-3'>{kidneyPickupDateTimeActual != '' ? kidneyPickupDateTimeActual : '- not specified -'}</div>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default SwapInfo;